import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/b6bef86fa8e68e852324b0c36aedfccd.jpg"
            alt="CLOG Transport Fleet"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        </div>
        
        <div className="relative z-10 w-full max-w-[1280px] mx-auto px-6 md:px-10 py-32 md:py-0">
          <div className="w-full md:max-w-[60%]">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white leading-tight mb-6 md:mb-8" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.3)' }}>
              Reliable Transport Capacity for Logistics Operators in Darwin
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-gray-200 leading-relaxed mb-8 md:mb-12">
              Professional subcontract transport support designed to strengthen established logistics operations across the Northern Territory.
            </p>
            <Link 
              to="/contact"
              className="inline-block bg-[#1A2B4A] text-white font-medium px-8 md:px-12 py-4 rounded-lg hover:bg-[#D97642] transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </section>

      {/* What We Do Section */}
      <section className="py-20 md:py-32 bg-white">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-20">
            <div>
              <div className="text-[#D97642] text-sm font-semibold uppercase tracking-wider mb-4">
                WHAT WE DO
              </div>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#2C2C2C] leading-tight">
                Structured Subcontract Transport Support
              </h2>
            </div>
            
            <div>
              <p className="text-base md:text-lg text-[#2C2C2C] leading-relaxed mb-6">
                CLOG TRANSPORT operates exclusively as a B2B subcontract transport partner.
              </p>
              
              <p className="text-base md:text-lg text-[#4A4A4A] leading-relaxed mb-8">
                We provide professional vehicles and drivers that integrate seamlessly into your existing dispatch, compliance, and operational systems — allowing you to increase capacity without increasing asset risk.
              </p>
              
              <p className="text-base md:text-lg text-[#2C2C2C] font-medium leading-relaxed mb-10">
                Our focus is simple: strengthen your operational performance while maintaining your service standards.
              </p>
              
              <div className="bg-[#F5F5F5] border-l-4 border-[#1A2B4A] p-5 md:p-6 mb-8">
                <p className="text-base font-semibold text-[#2C2C2C] mb-4">
                  Partnership Model
                </p>
                <ul className="space-y-2.5">
                  <li className="text-sm md:text-base text-[#2C2C2C] flex items-start">
                    <span className="mr-2">•</span>
                    <span>Dedicated vehicle and driver supply</span>
                  </li>
                  <li className="text-sm md:text-base text-[#2C2C2C] flex items-start">
                    <span className="mr-2">•</span>
                    <span>Flexible short and long-term support</span>
                  </li>
                  <li className="text-sm md:text-base text-[#2C2C2C] flex items-start">
                    <span className="mr-2">•</span>
                    <span>Peak demand capacity reinforcement</span>
                  </li>
                  <li className="text-sm md:text-base text-[#2C2C2C] flex items-start">
                    <span className="mr-2">•</span>
                    <span>Full integration into existing logistics workflows</span>
                  </li>
                </ul>
              </div>
              
              <div className="text-sm md:text-[15px] text-[#4A4A4A] space-y-1">
                <p>We do not operate public freight services.</p>
                <p>We work exclusively with established logistics companies.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Work With Us Section */}
      <section className="py-20 md:py-28 bg-[#1A2B4A]">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10">
          <div className="text-center mb-12 md:mb-16">
            <div className="text-[#D97642] text-sm font-semibold uppercase tracking-wider mb-4">
              WHY CLOG TRANSPORT
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white">
              Built for Darwin's Logistics Environment
            </h2>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            <div className="bg-white/10 border border-white/20 rounded-xl p-8 md:p-10 text-center">
              <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center">
                <i className="ri-map-pin-line text-5xl text-[#D97642]"></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-3">
                Locally Based in Darwin
              </h3>
              <p className="text-sm md:text-[15px] text-[#C5C5C5] leading-relaxed">
                We understand the operational realities of Northern Territory logistics — seasonal fluctuations, regional routes, and compliance requirements.
              </p>
            </div>

            <div className="bg-white/10 border border-white/20 rounded-xl p-8 md:p-10 text-center">
              <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center">
                <i className="ri-hand-heart-line text-5xl text-[#D97642]"></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-3">
                Operational Flexibility
              </h3>
              <p className="text-sm md:text-[15px] text-[#C5C5C5] leading-relaxed">
                Scale your transport capacity without expanding your internal fleet.
              </p>
            </div>

            <div className="bg-white/10 border border-white/20 rounded-xl p-8 md:p-10 text-center">
              <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center">
                <i className="ri-truck-line text-5xl text-[#D97642]"></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-3">
                Professional Representation
              </h3>
              <p className="text-sm md:text-[15px] text-[#C5C5C5] leading-relaxed">
                Well-maintained vehicles and trained drivers aligned with your brand standards.
              </p>
            </div>

            <div className="bg-white/10 border border-white/20 rounded-xl p-8 md:p-10 text-center">
              <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center">
                <i className="ri-time-line text-5xl text-[#D97642]"></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-3">
                Partnership-Focused
              </h3>
              <p className="text-sm md:text-[15px] text-[#C5C5C5] leading-relaxed">
                We prioritise long-term operational relationships over short-term volume.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}